<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">{{ modalTitle }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
    aria-label="Close Icon"
  >
    Close
  </button>
</div>
<div class="modal-body pb-0" hsDraggable="modal-dialog">
  <nf-form-control label="Description" for="longText">
    <textarea
      id="longText"
      [(ngModel)]="description"
      [rows]="4"
      class="form-control"
      [class.is-invalid]="error"
      (ngModelChange)="onDescriptionChange()"
    >
    </textarea>
    <div class="invalid-feedback" *ngIf="error">
      {{ error }}
    </div>
  </nf-form-control>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <button
    nf-button
    ngbAutoFocus
    (click)="activeModal.dismiss()"
    aria-label="Cancel Button"
  >
    Cancel
  </button>
  <button
    nf-button="save"
    (click)="validateAndSave()"
    [disabled]="!isValid"
    aria-label="Save Button"
  >
    Save
  </button>
</div>
